(function() {
	document.querySelectorAll(".accordion__tab").forEach(tab => {
		let button = tab.querySelector("button[data-container][data-tab]");
		let content = tab.querySelector(".accordion-tab__content");
		let element = tab.closest('.accordion, .tabs');
        let collapseMode = element.dataset.mode === "collapse";
        let tabsMode = element.dataset.mode === "tabs";

		button.addEventListener("click", event => {
			event.preventDefault();
			// CSS Variable auslesen
			let transitionValue = getComputedStyle(content).getPropertyValue('--transition');
			// Parseint auf die transition time und multiplkation für millisekunden
			// Entfernen aller nicht zahlen
			let timeoutTime = parseInt(transitionValue.replace(/\D/g, ""));
			let ariaExpanded = button.getAttribute("aria-expanded").toLowerCase();

			let newState = ariaExpanded === "true" ? "false" : "true";

			let container = event.target.getAttribute("data-container");
			let tabEl = event.target.getAttribute("data-tab");

			// set state for current tab, prevent hiding active tab content in tab-mode
			if(!(tabsMode && newState === "false")) {
				element.querySelectorAll("button[data-container='" + container + "'][data-tab='" + tabEl + "']").forEach(function(element) {
					element.setAttribute("aria-expanded", newState)
				});
			}

			// set state for other tabs, prevent hiding other tabs content in collapse-mode
			if(!collapseMode && newState === "true") {
				element.querySelectorAll("button[data-container='" + container + "']:not(button[data-tab='" + tabEl + "'])").forEach(element => element.setAttribute("aria-expanded", "false"));
			}

			if(newState === "false") {
				// Beim zuklappen animation abwarten mit ausgelesener transition time und dann display none
				tab.classList.add('accordion-tab--closed');
                content.classList.toggle('accordion-tab__content--transitioning');
				content.removeAttribute('style');

				setTimeout(function() {
                    content.classList.toggle('accordion-tab__content--transitioning');
					tab.classList.toggle('accordion-tab--opened');
				}, timeoutTime);

			} else {
				// Beim aufklappen display block drauf und settimeout mit 0 sekunden auf die höhe
				tab.classList.toggle('accordion-tab--opened');
                content.classList.toggle('accordion-tab__content--transitioning');

				// Nachdem der content display block hat lesen wir erst die höhe aus, da ansonsten sie 0 ist
				let tabInnerHeight = content.querySelector(".accordion-tab__content-inner").offsetHeight;

				setTimeout(function() {
					tab.classList.remove('accordion-tab--closed');
					content.style.maxHeight = tabInnerHeight + 'px';
				}, 0);

                // Während die Transition passiert z.b. für overflow:hidden
                setTimeout(function() {
                    content.classList.toggle('accordion-tab__content--transitioning');
                }, timeoutTime);
			}
		});
	});
})();
